import { Component, OnInit} from '@angular/core';
import { VesselService, VesselModel, PagerService, AlertService, TableHeader, CommonService } from '../../services/index'
import { Util } from '../../utils/util'
import _ from 'lodash';
import similarity from 'string-similarity';

declare var $:any;

@Component({
  selector: 'vessel-list',
  templateUrl: 'vessel-list.html' 
})
export class VesselList implements OnInit{

    allVesselList: Array<VesselModel> = new Array();
    vesselList: Array<VesselModel> = new Array();
    pager: any = {};
    pagedItems: Array<VesselModel> = new Array();

    dateFomatter: Function = Util.dateFomatter;

    openVesselId:number;
    clickedVesselId:number;
    isShowVesselDetail:boolean = false;
    
    condition:ConditionSearch = new ConditionSearch();

    headerList:Array<TableHeader> = null;

    constructor(
        private vesselService:VesselService,
        private pagerService: PagerService,
        private alertService:AlertService,
        private commonService:CommonService
    ) {
        this.makeHeader();
        commonService.headerSortedEmit.subscribe(data =>{
            if(data.type == 0){
                this.allVesselList = data.data;
                this.searchVessel();
            }
          });
        commonService.clearHeaderEmit.subscribe(data =>{
            if(data.type == 0){
                this.headerList = data.headerList;
            }
        });
    }

    ngOnInit(){
        this.getVesselList(true);
    }

    makeHeader(){
        this.headerList = new Array<TableHeader>();
        this.headerList.push(new TableHeader(0, 'vslId', 'No.', true));
        this.headerList.push(new TableHeader(1, 'vslNm', '선박 이름', true));
        this.headerList.push(new TableHeader(2, 'match', '일치율', true));
        this.headerList.push(new TableHeader(3, 'builtYy', '제작년도', true));
        this.headerList.push(new TableHeader(4, 'cntryCd', '국가코드', true));
        this.headerList.push(new TableHeader(5, 'cntryNm', '국가', true));
        this.headerList.push(new TableHeader(6, 'depth', '깊이', true));
        this.headerList.push(new TableHeader(7, 'length', '길이', true));
        this.headerList.push(new TableHeader(8, 'width', '넓이', true));
        this.headerList.push(new TableHeader(9, 'dwt', 'DWT', true));
        this.headerList.push(new TableHeader(10, 'imoNo', 'IMO', true));
        this.headerList.push(new TableHeader(11, 'mmsi', 'MMSI', true));
        this.headerList.push(new TableHeader(12, 'callSign', '무선통신', true));
        this.headerList.push(new TableHeader(13, 'operCd', '운영사코드', true));
        this.headerList.push(new TableHeader(14, 'operNm', '운영사', true));
        this.headerList.push(new TableHeader(15, 'plug', 'PLUG', true));
        this.headerList.push(new TableHeader(16, 'speed', '속도', true));
        this.headerList.push(new TableHeader(17, 'teu', 'TEU', true));
        //this.headerList.push(new TableHeader(18, 'waterLine', '운행 라인', true));
        this.headerList.push(new TableHeader(19, 'grt', 'GRT', true));
        this.headerList.push(new TableHeader(20, 'lastNm', '수정자', true));

    }

    getVesselList(isInit:boolean){
        this.vesselService.getVesselList().subscribe(
            res =>{
                if(res != null && res.result){
                    this.vesselList = res.data;
                    this.allVesselList = res.data;

                    if(!isInit){
                        let tempIndex = this.clickedVesselId;
                        this.clickedVesselId = null;
                        this.searchVessel();
                        this.tableRowClick(tempIndex);
                    }else{
                        this.setPage(1);
                    }
                }
            }
        );
    }

    refreshVesselList(){
        this.getVesselList(false);
        this.closeDetail();
    }

    setPage(page:number){
        
        this.pager = this.pagerService.getPager(this.vesselList.length, page, 15);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager.totalPages) {
          this.pager = this.pagerService.getPager(this.vesselList.length, this.pager.totalPages);
        }
    
        this.pagedItems = this.vesselList.slice(this.pager.startIndex, this.pager.endIndex + 1);

    }

    tableRowClick(id:number){
        if(id == this.clickedVesselId){
            return ;
        }
        this.clickedVesselId = id;
    }

    searchVessel(event?) {
    
        if(event && event.keyCode != 13) return ;

        var filterValue = this.condition.text;

        if(this.allVesselList.length < 1) return;

        this.vesselList = _.filter(this.allVesselList, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) {
            this.setPage(1);
            // this.commonService.clearOrderByHeader(this.headerList, 0);
        }
        else {
            this.setPage(this.pager.currentPage);
        }

        this.clickedVesselId = null;
    }

    addVessel(){
        this.openVesselId = null;
        this.isShowVesselDetail = true;
    }

    findVessel(event){

        if(!event) return

        let operVslNm = event.operVslNm;
        let vesselMapId = event.vesselMapId;

        if(operVslNm == null || operVslNm == undefined || operVslNm.length < 1) return 

        this.vesselList = _.filter(this.allVesselList, (item:VesselModel) => {
            if (!item.vslNm) return false;
            if (similarity.compareTwoStrings(operVslNm, item.vslNm) > 0.3) {
                item.match = similarity.compareTwoStrings(operVslNm, item.vslNm).toFixed(2);
                return true;           
            }
        });

        this.vesselList = _.orderBy(this.vesselList, ['match'], ['desc']);
    
        this.setPage(1);

        this.clickedVesselId = null;
    }

    openVesselDetail(vesselId:number){
        this.openVesselId = vesselId;
        this.isShowVesselDetail = true;
    }

    clearClickedVesselId(){
        this.clickedVesselId = null;
    }

    closeDetail(){
        this.isShowVesselDetail = false;
        this.openVesselId = null;
    }
}

class ConditionSearch{
    text:string = "";
}


// WEBPACK FOOTER //
// ./src/app/containers/vessel/vessel-list.ts